import Slideshow from "../typescript/modules/slideshow";
import UmbracoForm from "../typescript/modules/umbraco-form";

const slideshows = document.querySelectorAll('.js-slideshow') as NodeListOf<HTMLElement>;
for (let i = 0; i < slideshows.length; i++) {
	new Slideshow(slideshows[i]);
}

const umbracoForm = document.querySelector('.js-umbraco-form') as HTMLFormElement;
if (umbracoForm) {
	new UmbracoForm(umbracoForm);
}
